import { LandingPage } from '../LandingPage';
import { barbersConfig } from './config';

export default function BarbersLandingPage() {
  return <LandingPage config={barbersConfig} />;
}
